import { NavigableButton } from '@carvana/ds-button';
import { useEffect } from 'react';
import COOKIES from '~/constants/srp/cookies';
import type InventoryConditionalTile from '~/contracts/srp/InventoryConditionalTile';
import { getNccHref } from '~/utilities/srp/ncc/getNccVariant';
import { PromoBanners } from './constants';
import { useSendViewedBannerEvent } from './hooks';
import { getBannerName, setBannerDismissedCookie } from './utils';

type OwnProps = {
  metaData: InventoryConditionalTile['metaData'];
};

const bannerName = getBannerName(PromoBanners.NCC);

export default function NccBanner({ metaData }: OwnProps) {
  const sendViewedBannerEvent = useSendViewedBannerEvent();
  const href = getNccHref(metaData);

  useEffect(() => {
    sendViewedBannerEvent(bannerName);
  }, [sendViewedBannerEvent]);

  function handleDismiss() {
    setBannerDismissedCookie(PromoBanners.NCC, COOKIES.dismissedNccBanner);
  }

  return (
    <div data-testid="ncc-banner">
      {/* Placeholder — final visuals/copy land in variant stories */}
      <p>New Cars at Carvana</p>
      <NavigableButton
        data-adobe-id={null}
        data-analytics-attributes={JSON.stringify({
          category: bannerName,
          label: 'Shop New'
        })}
        data-analytics-id="Banner"
        href={href}
        size="sm"
        variant="primary"
        width="auto"
      >
        Shop New Inventory
      </NavigableButton>
      <button
        data-adobe-id={null}
        data-analytics-attributes={JSON.stringify({
          category: bannerName,
          label: 'Dismiss'
        })}
        data-analytics-id="Banner"
        data-testid="ncc-banner-dismiss"
        onClick={handleDismiss}
        type="button"
      >
        Dismiss
      </button>
    </div>
  );
}
